import irisHttpClient from 'API/clients/iris/client'
const basepath = 'auth'

const api_logout = () => irisHttpClient.get(`/${basepath}/logout/`)
const get_csrf = () => irisHttpClient.get(`/${basepath}/csrf_token/`)

export {
    api_logout,
    get_csrf
}